export default __webpack_public_path__ + "static/MonitorSection_it-3ee8863d122869ce0cf8d7fb832d92bf.png";